module.exports = __webpack_public_path__ + "img/logo.19086a2.png";